export enum WattiActionTypes {
  API_RESPONSE_SUCCESS = "@@watti/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@watti/API_RESPONSE_ERROR",

  GET_WATTI_TEMPLATES = "@@watti/GET_WATTI_TEMPLATES",
  SEND_WATTI_BROADCAST = "@@watti/SEND_WATTI_BROADCAST",
}
